import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../css/admin.css";

const AdminLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminRole");
    navigate("/admin/login");
  };

  return (
    <div className="admin-wrapper">

      {/* ── Hamburger (mobile only) ── */}
      <button
        className="admin-sidebar-toggle"
        onClick={() => setSidebarOpen(true)}
        aria-label="Open menu"
      >
        ☰
      </button>

      {/* ── Overlay ── */}
      <div
        className={`admin-sidebar-overlay ${sidebarOpen ? "open" : ""}`}
        onClick={() => setSidebarOpen(false)}
      />

      {/* ── SIDEBAR ── */}
      <aside className={`admin-sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="admin-logo">🚗 FraudCheck — Car Rental</div>

        <nav>
          {[
            { to: "/admin/dashboard",     label: "📊 Dashboard" },
            { to: "/admin/frauds",        label: "🚨 Fraud Reports" },
            { to: "/admin/owners",        label: "👥 Owners" },
            { to: "/admin/subscriptions", label: "💳 Subscriptions" },
            { to: "/admin/plans", label: "📋 Plans" },
            { to: "/admin/settings", label: "⚙️ Settings" },
            { to: "/admin/alerts",        label: "🔔 Alerts" },
            { to: "/admin/logs", label: "📋 Activity Logs" },
            { to: "/admin/analytics", label: "📊 Analytics" },
            { to: "/admin/invoices",  label: "🧾 Invoices" },
            { to: "/admin/profile",       label: "👤 Profile" },
          ].map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              onClick={() => setSidebarOpen(false)}
              className={({ isActive }) => isActive ? "active" : ""}
            >
              {label}
            </NavLink>
          ))}

          <button className="admin-logout-btn" onClick={handleLogout}>
            🚪 Sign Out
          </button>
        </nav>
      </aside>

      {/* ── MAIN ── */}
      <main className="admin-main">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;